import { render, staticRenderFns } from "./CreateInfoCardUtil.vue?vue&type=template&id=83e560ca&scoped=true&"
import script from "./CreateInfoCardUtil.vue?vue&type=script&lang=js&"
export * from "./CreateInfoCardUtil.vue?vue&type=script&lang=js&"
import style0 from "./CreateInfoCardUtil.vue?vue&type=style&index=0&id=83e560ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e560ca",
  null
  
)

export default component.exports